import React, { useState } from "react";
import TeamLogo from "./TeamLogo";
import MVMIcon from "../Common/MVMIcon";
import TeamControls from "./TeamControls";
import ParticipantItem from "./Participant";
import { MissionService } from "@/common/api/Services/Mission";
export default function Team({ team, missionId }) {
    const [participants, setParticipants] = useState();
    const imageUrl = team.imageExtension === ""
        ? ""
        : "/uploads/team_images/" + team.id + "_" + team.imageExtension;
    const getParticipants = async () => {
        try {
            const res = await MissionService.getTeamParticipants(team.id, missionId);
            setParticipants(res);
        }
        catch (e) {
            // console.log(e);
        }
    };
    const onExtend = () => {
        getParticipants();
    };
    const renderParticipants = () => {
        if (!participants || participants.length <= 0) {
            return null;
        }
        return participants.map((participant) => (React.createElement(ParticipantItem, { key: participant.id, participant: participant, teamId: team.id })));
    };
    const renderName = () => {
        if (team.id > 0) {
            return React.createElement("h2", { className: 'ms-3 me-1 black' }, team.name);
        }
        return (React.createElement("div", { className: 'd-flex align-items-center', title: 'These people have not been assigned to a team and will show as individuals on the map. You can move them into a team if you want', 
            //@ts-ignore
            rel: 'tooltip' },
            React.createElement("h2", { className: 'ms-3 me-1 black' }, team.name),
            React.createElement(MVMIcon, { width: 14, height: 14, icon: 'question-circle' })));
    };
    return (React.createElement("div", { className: 'team-wrap' },
        React.createElement("div", { className: 'team' },
            React.createElement(TeamLogo, { id: team.id, imageUrl: imageUrl }),
            React.createElement("div", { className: 'd-flex flex-fill align-items-center justify-content-between' },
                renderName(),
                React.createElement("div", { className: 'd-flex justify-content-between align-items-center' },
                    React.createElement("p", { className: 'm-0' }, team.numUsers),
                    React.createElement(TeamControls, { teamId: team.id, teamName: team.name, imageUrl: imageUrl, onExpand: onExtend, editable: team.id > 0, expandable: team.numUsers > 0 })))),
        React.createElement("div", { className: 'team-users collapse multi-collapse', id: `collapse-${team.id}` }, renderParticipants())));
}
